var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DxPopover',{attrs:{"visible":_vm.showPopover,"shading":false,"target":"#notificationsBar","position":{
      my: 'top center',
      at: 'right bottom',
    },"shading-color":"rgba(0, 0, 0, 0.5)"},on:{"hiding":_vm.hide}},[_c('SummaryAccordion',{attrs:{"loaded":_vm.loaded}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }